export interface historyQuotaEntities {
  historyQuotaId: string;
  action: string;
  role: string;
  updatedBy: string;
  quotaId: string;
  createdAt: string;
  updatedAt: string;
}
export const historyQuotaEntities_INIT: historyQuotaEntities = {
  historyQuotaId: "",
  action: "",
  role: "",
  updatedBy: "",
  quotaId: "",
  createdAt: "",
  updatedAt: "",
};
export interface AllHistoryQuotaEntities {
  count: number;
  data: historyQuotaEntities[];
}
export const AllHistoryQuotaEntities_INIT: AllHistoryQuotaEntities = {
  count: 0,
  data: [historyQuotaEntities_INIT],
};
